/**
 * GET PUBLICATION FILE
 */
export const GET_SECTION_FILE_REQUEST = 'GET_SECTION_FILE_REQUEST';

export const getSectionFile = sectionId => ({
    type: GET_SECTION_FILE_REQUEST,
    sectionId
});

/**
 * CHECK SECTION FILE
 */
export const CHECK_SECTION_FILE_REQUEST = 'CHECK_SECTION_FILE_REQUEST';
export const CHECK_SECTION_FILE_SUCCESS = 'CHECK_SECTION_FILE_SUCCESS';
export const CHECK_SECTION_FILE_FAILURE = 'CHECK_SECTION_FILE_FAILURE';

export const checkSectionFile = sectionId => ({
    type: CHECK_SECTION_FILE_REQUEST,
    sectionId
});

export const checkSectionFileSuccess = alignmentDocumentName => ({
    type: CHECK_SECTION_FILE_SUCCESS,
    alignmentDocumentName
});

export const checkSectionFileFailure = () => ({
    type: CHECK_SECTION_FILE_FAILURE
});

/**
 * DELETE SECTION FILE
 */
export const DELETE_SECTION_FILE_REQUEST = 'DELETE_SECTION_FILE_REQUEST';
export const DELETE_SECTION_FILE_SUCCESS = 'DELETE_SECTION_FILE_SUCCESS';
export const DELETE_SECTION_FILE_FAILURE = 'DELETE_SECTION_FILE_FAILURE';

export const deleteSectionFile = sectionId => ({
    type: DELETE_SECTION_FILE_REQUEST,
    sectionId
});

export const deleteSectionFileSuccess = () => ({
    type: DELETE_SECTION_FILE_SUCCESS
});

export const deleteSectionFileFailure = () => ({
    type: DELETE_SECTION_FILE_FAILURE
});

/**
 * UPLOAD SECTION FILE
 */
export const UPLOAD_SECTION_FILE_REQUEST = 'UPLOAD_SECTION_FILE_REQUEST';
export const UPLOAD_SECTION_FILE_SUCCESS = 'UPLOAD_SECTION_FILE_SUCCESS';

export const uploadSectionFile = (
    sectionId,
    uploadedFile
) => ({
    type: UPLOAD_SECTION_FILE_REQUEST,
    sectionId,
    uploadedFile
});

export const uploadSectionFileSuccess = () => ({
    type: UPLOAD_SECTION_FILE_SUCCESS
});



// WEBPACK FOOTER //
// ./app/containers/curriculum-documents/actions.js